import { Link } from 'react-router-dom'

import PlatformSettingIcon from '@/assets/icons/platform-setting.svg?react'
import { Trans } from '@/components'
import { useUnifiedContext } from '@/contexts/UnifiedContext'

import { UserDropdownItem } from './UserDropdownItem'

export function UserProfileSection() {
  const { mode } = useUnifiedContext()
  const profilePath = mode === 'platform' ? '/profile' : '/team/profile'

  return (
    <Link className="block" to={profilePath}>
      <UserDropdownItem
        icon={PlatformSettingIcon}
        label={<Trans i18nKey="header.userDropdown.platformSetting">Platform Setting</Trans>}
      />
    </Link>
  )
}
